import { styled } from 'styled-components';

import SvgIcon from '@lcsc-ui/components/SvgIcon';
import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';

const ScrollbarCustomUl = styled.ul`
  -webkit-overflow-scrolling: touch;
  white-space: nowrap;
  scroll-behavior: smooth;
  &::-webkit-scrollbar {
    height: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.35);
    border-radius: 19px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 19px;
  }
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.35) transparent;
`;

const GroupSendCoupon = ({ data, targetLink, onClose }) => {
  if (!data?.couponList?.length) return <></>;
  function handleOpen() {
    buriedPoint({
      ty: 'click',
      cp: 'float_adv',
      op: 'window_in_central',
      pf: 'pc',
      data: { Based_id: data?.autoSubgroupId, ck: 'open', hf: targetLink },
    });
  }

  function handleClose() {
    buriedPoint({
      ty: 'click',
      cp: 'float_adv',
      op: 'window_in_central',
      pf: 'pc',
      data: { Based_id: data?.autoSubgroupId, ck: 'close', hf: targetLink },
    });
    onClose();
  }

  const { couponList } = data;
  if (!couponList.length) return <></>;
  return (
    <section className={'absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%]'}>
      <div
        className={
          'ml-[38px] h-[119px] w-[237px] translate-y-[12px]  bg-[url(//static.szlcsc.com/ecp/assets/newWeb/www/home/group/group-modal-title.png)] ' +
          'bg-[length:100%_100%] bg-no-repeat'
        }
      ></div>
      <div
        className={
          'w-[311px] rounded-[10px] bg-[url(//static.szlcsc.com/ecp/assets/newWeb/www/home/group/group-modal-bg.png)] px-[15px] pb-[18px] pt-[24px] ' +
          'bg-[length:100%_100%] bg-no-repeat'
        }
      >
        <div className={'mb-[20px] text-center text-[20px] font-medium text-[#1B324F]'}>专属优惠券</div>
        <ScrollbarCustomUl className={'max-h-[320px] overflow-y-auto overflow-x-hidden'}>
          {couponList.map((item, index) => {
            let leftDom = (
              <div className={'max-w-[60px] truncate text-[12px] font-semibold'} title={`￥${item?.couponAmount}`}>
                <span>￥</span>
                <span className={'text-[24px]'}>{item?.couponAmount}</span>
              </div>
            );
            if (item?.couponType === 'freight' && item?.isFreeExpress) {
              leftDom = <div className={'max-w-[60px] truncate text-[24px] font-semibold'}>包邮</div>;
            }
            if (item?.couponType === 'discount') {
              leftDom = (
                <div className={'max-w-[60px] truncate font-semibold'} title={`${item?.couponDiscount * 10}折`}>
                  <span className={'text-[24px] '}>{item?.couponDiscount * 10}</span>
                  <span className={'text-[12px]'}>折</span>
                </div>
              );
            }
            return (
              <li
                key={index}
                className={
                  'mb-[10px] h-[92px] w-[281px] bg-[url(//static.szlcsc.com/ecp/assets/newWeb/www/home/group/group-modal-coupon-bg.png)] ' +
                  'bg-[length:100%_100%] bg-no-repeat'
                }
              >
                <div className={'flex h-[92px]'}>
                  <div className={'flex w-[72px] flex-col items-center justify-center text-[#FF4434] '}>
                    {leftDom}
                    <div
                      className={'max-w-[60px] truncate text-[12px] font-normal'}
                      title={`满${item?.minOrderMoney}可用`}
                    >
                      满{item?.minOrderMoney}可用
                    </div>
                  </div>
                  <div className={'flex flex-1 flex-col items-center justify-center'}>
                    <div
                      className={'mb-[2px] w-[155px] truncate text-[14px] font-medium leading-[20px] text-[#000000]'}
                      title={item?.couponName}
                    >
                      {item?.couponName}
                    </div>
                    <div className={'text-[10px] w-[155px] font-normal leading-[14px] text-[#666666]'}>
                      有效期至:{item?.couponValidEndTime}
                    </div>
                  </div>
                </div>
              </li>
            );
          })}
        </ScrollbarCustomUl>
        <div className={'mt-[15px] flex justify-center'}>
          <a
            href={targetLink}
            rel="nofollow"
            onClick={handleOpen}
            target="_blank"
            className={
              'flex h-[51px] w-[165px] cursor-pointer items-center justify-center bg-[url(//static.szlcsc.com/ecp/assets/newWeb/www/home/group/group-modal-btn-bg.png)] text-[18px] font-semibold text-white ' +
              'bg-[length:100%_100%] bg-no-repeat'
            }
          >
            立即查看
          </a>
        </div>
      </div>
      <div className={'mt-[15px] flex justify-center'}>
        <SvgIcon
          app="common"
          iconName={'group-modal-close'}
          onClick={handleClose}
          className={'h-[28px] w-[28px] cursor-pointer'}
        />
      </div>
    </section>
  );
};

export default GroupSendCoupon;
